import { j as n } from "../../../jsx-runtime-B6kdoens.js";
import { a as i } from "../../../index-CROKJrb5.js";
import { c as s, f as m } from "../../../create-component-CBAeEoQ6.js";
const x = s(
  "NavigationItem",
  m(
    ({ as: t, children: e, className: o, href: r, ...c }, a) => {
      const u = t || (r ? "a" : "button");
      return /* @__PURE__ */ n.jsx(
        u,
        {
          href: r,
          className: i(
            "cur-text-line-height-h2 cur-flex cur-flex-nowrap cur-items-center cur-whitespace-nowrap cur-p-3 cur-px-3 cur-text-body cur-font-bold hover:cur-bg-surface-highlight hover:cur-text-primary hover:cur-no-underline focus:cur-bg-surface-brand-light focus:cur-text-primary active:cur-bg-surface-brand-light",
            o
          ),
          type: "button",
          ref: a,
          ...c,
          children: e
        }
      );
    }
  )
);
export {
  x as NavigationItem
};
//# sourceMappingURL=index.js.map
